import ArtistPreset from '@common/types/artist-preset/artist-preset';
import { CallApi, handleJSONResponse } from './common';

const callAPI = CallApi('presets');

export const get = async (artistId: string): Promise<ArtistPreset> => {
  const response = await callAPI(`/${artistId}`, 'GET');

  return await handleJSONResponse(response);
};

export const update = async (
  artistId: string,
  presets: ArtistPreset
): Promise<ArtistPreset> => {
  const response = await callAPI(`/${artistId}`, 'PUT', presets);

  return await handleJSONResponse(response);
};
